<template>
  <div class="home">
    <v-header :go-back="false" :if-login="islogin" :mine='true'></v-header>
   	<v-introduction v-if="isintroduction" @introductC="introductClose"></v-introduction>
   	<div class="allinfo">
    	<div class="title" ref="title">
	    	<ul>
	    		<p v-if="pagestatu == 1002" @click="showintroduct"><img src="../../../static/img/account2/introduction.png" alt="">{{$t('introduction.sure')}}</p>
	    		<li v-if="pagestatu == 1000">{{$t('petstatus.petinfo')}}</li>
	    		<li v-if="pagestatu == 1001">{{$t('petstatus.petlookafter')}}</li>
	    		<li v-if="pagestatu == 1002">{{$t('petstatus.petmissing')}}</li>
	    		<li v-if="pagestatu == 1003">{{$t('petstatus.petfinding')}}</li>
	    	</ul>
    	</div>
		  <div class="petinfo">
		    <div class="petinfo-main"  style="height: 177px;">
		      <div>
		        <div class="head_img" v-show="!ifedit">
		          <img :src="portrait" style="margin: auto;display: block;">
		        </div>
		        <div class="pet">
		          <ul>
		            <li>
		              <span class="petNewsIcon"><img src="../../../static/img/account2/petNick.png" alt=""></span>
		              <p class="infoBox" v-show="!ifedit">{{petname}}</p>
		            </li>
		            <li>
			            <span  class="petNewsIcon" style="width:100%;"><img src="../../../static/img/account2/petType.png" alt=""></span>
			            <p v-show="!ifedit">{{petType}}</p>    
			        	</li>
		            <li>
		              <span class="petNewsIcon"><img src="../../../static/img/account2/sex.png" alt=""></span>
		              <p v-show="!ifedit">{{value}}</p>
		              <div class="selectsex" v-show="ifedit">
		              </div>
		            </li>
		          </ul>
		        </div>
		      </div>
		    </div>
    		<div class="lostsign" v-if="lostsign">
        	<img src="../../../static/img/petlosted.png" alt="" />
        	<li>
        		<span v-for="item in losttime.slice(0,10)">{{item}}</span>
        	</li>
        </div>
		  </div>
		  
		<div class="mynews">
      <div class="new">
        <span class="title" v-show="false">{{$t('mynews.masternews')}}</span>
			<div class="news">
				<div class="pos"><span><img src="../../../static/img/account2/nick.png" alt=""></span>
					<input :disabled="isable" v-model="nc" maxlength="12" ref='name'  :placeholder="$t('mynews.mastername')" >
				</div>
				<div class="pos"><span><img src="../../../static/img/account2/email.png" alt=""></span>
					<input :disabled="isable" v-model="em"  :placeholder="$t('mynews.masteremail')" >
				</div>
				<div class="pos"><span><img src="../../../static/img/account2/phone.png" alt=""></span>
					<input :disabled="isable" v-model="phone"  :placeholder="$t('mynews.masterphone')" > 
				</div>
				<div class="pos"><span><img src="../../../static/img/account2/addr.png" alt=""></span>
					<input :disabled="isable" v-model="adr"  :placeholder="$t('mynews.masteradr')" >
				</div>
			</div>
      </div>
		</div>
    </div>   	
   	
   	<div class="releaseSearch">
        <div class="main">
        	<div class="disable" v-if="isable"></div>
            <div style="height:400px;">
                
                <div class="describe">
                	<span>主人留言:</span>
                    <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 4}" maxlength='200' :placeholder="$t('releaseSearch.decription')" v-model="textarea2" >
                    </el-input>
                </div>
                <div class="loseplace">
                	<span><img src="../../../static/img/account2/lostaddr.png" alt="" />走失地点</span>
                    <p>{{place}}</p>
                </div>
 				<div class="time">
                    <p><img src="../../../static/img/account2/losttime.png" alt="" />{{$t('releaseSearch.losttime')}}</p>
                    <div class="block">
                        <el-date-picker v-model="losttime" type="date" :default-value="losttime" value-format="yyyy-MM-dd" :picker-options="pickerOptions" ref='datetime'  >
                        </el-date-picker>
                    </div>
               </div>
                <div class="petphoto">
                    <p><img src="../../../static/img/account2/lostimg.png" alt="" />{{$t('releaseSearch.petImg')}}</p>  
                    <img :src="imgflag?avatar:avatar1" v-show="isshow" />                                      
                    <img :src="imgflag1?avatar2:avatar1"  v-show="isshow1" />                                     
                    <img :src="imgflag2?avatar3:avatar1"  v-show="isshow2" />
                    
                </div>
            </div>
        </div>
    </div>
   
   	
  </div>
</template>
<script >
import EXIF from "exif-js/exif.js";
import { getDevices } from "../../deviceApi/index.js";
import header from "../../components/header";
import store from "../../store/store.js";
import lostpetinfo from "../myAccount/lostpetinfo";
import menus from "../home/menus";
import introduction from "../login/introduction";
import scanningrecord from "../login/scanningrecord";
import { index,bind,add_pet,bind_pet,updateBasicInfo,unbind } from "../../apiNew/index.js";
import Qs from "qs";
import { getpet,updatePet,addPet,addPublish,addScanner } from "../../ClientServerApi/index.js";
export default {
  name: "qrFindPet",
  data() {
    return {
      islogin: true,
      infos: "",
      loginsuccess: false,
      loginshowflag: true,
      getToken: sessionStorage["token"],
      imei: "",
      menus:false,//右下角菜单按钮
      menu:false,
      losttime:"",
      lossbtn:false,//发布走失按钮
      lostsign:true,//走失标志
      scanningrecords:false,//扫码记录组件
      isintroduction:false,//简介组件
      addDeviceBtn: false,
      deviceCode: "", //获得点击的设备devicedCode
      pagestatu:1002,//页面登录状态属性
      ifedit: false,//宠物信息是否可以编辑
      isable:true,//主人信息输入框
      petname: "",
      petType: "",
      gender: "",
      value: "",
      selpetType: false,//品种选择
      petbelong: "",
      portrait:"",
      height:1,
      weight:1,
      birthday:"",
      color:"",
      character:"",
      petId:"",
      nc: "",
      em: "",
      phone: "",
      adr: "",
      options: [
        {
          value: this.$t("prompt.boy"),
          label: this.$t("prompt.boy")
        },
        {
          value: this.$t("prompt.girl"),
          label: this.$t("prompt.girl")
        }
      ],
      flag: false,
      flag1: false,
      flag2: false,
      flag3: false,
      flag4: false,
      flag5: false,
      flag6:false,
      flag7: false,
      flag8: false,
      flag9: false,
      flag10: false,
      flag11: false,
      scrollY:0,
      showflag: false,
      showflag1: false,
      isshow: true,
      imgflag: false,
      avatar: "",
      avatar1: "",
	    avatar1: require("../../image/addphoto.png"),
	    avatar2: "",
	    avatar3: "",
	    imgflag: false,
	    imgflag1: false,
	    imgflag2: false,
      
	    isable:true,//遮罩层屏蔽编辑操作,判读保存取消按钮显示
	    isshow: true,
	    isshow1: true,
	    isshow2: true,
	    petimg: require("../../image/addphoto.png"),
	    msg: this.$t("addpet.trueAdd"),
	    tmsg: this.$t("addpet.trueAdd"),
	    cmsg: this.$t("addpet.submiting"),
	    id: "",
	    lat: "",
	    lng: "",
	    mobile: "",
	    email: "",
	    address: "",
	    nickname: "",
	    personinfo: "",
	    lossimg:[],
	    featurePhoto: [],
	    textarea2: "",
	    value: "",
	    isShow: false,
	    choose: "",
	    place: "",
	    pickerOptions: {
	        disabledDate: time => {
	            return time.getTime() > Date.now();
	        }
	    },      
     
    };
  },
  mounted() { 

  },
  created() {
    //查询本地是否有token，有则自动登录，若没有则检查session是否
   
    	let accessToken = this.GetQueryString("accessToken");
    	localStorage.setItem('token',accessToken);
    	this.index();
  },
  watch:{

  },
  methods: {
//获取url参数=========
  	GetQueryString(name){
		     var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
		     var r = window.location.search.substr(1).match(reg);
		     if(r!=null)return  unescape(r[2]); return null;
		},
//获取用户信息==========
		index(){
			setTimeout(() => {
					//let code = localStorage.deviceCode;
					let id = this.GetUrlParam("deviceCode");//获取吊牌id
					console.log('吊牌id:',id)
					var params = Qs.stringify({
						deviceCode :id,
					});
					index(params)
			    .then(res => {
						//console.log("获取后台返回数据：",res);
			      if (res.data.header.status == 1000) {
							  //如果用户已登陆，获取相关宠物和主人信息
							  this.imgflag = true;
		            this.petname = res.data.data.pet.name;
						    this.petType = res.data.data.pet.type;
								this.portrait = res.data.data.pet.portrait;
								this.portrait1 = res.data.data.pet.portrait;
								this.avatar = res.data.data.pet.portrait;
								this.petbelong = res.data.data.pet.type;
						    this.gender = res.data.data.pet.gender;
						    this.value = res.data.data.pet.gender;
				        this.nc = res.data.data.user.nickname;
				        this.em = res.data.data.user.email;
				        this.phone = res.data.data.user.mobile;
				        this.adr = res.data.data.user.address;
				        this.losttime = res.data.data.search.loseTime;
				        let lossimgs = res.data.data.search.featurePhoto;
				        this.getlossimg(lossimgs);
								localStorage.setItem('publishId',res.data.data.search.id);				        
				        this.place = res.data.data.search.lostPlace;
				        this.textarea2 = res.data.data.search.content;
				        
				        this.addScanner();//增加扫码记录
			      }else{
				      this.$alert("<p>" + res.data.header.message + "</p>", {
								confirmButtonText: this.$t("prompt.sure"),
								dangerouslyUseHTMLString: true
								});
							return false;
			      }
			    })
			    .catch(error => {
			      console.log(error);
			    });
			}, 200);
		},
//=====添加扫码记录=========
		addScanner(){
					this.getNowFormatDate();
					let time = this.losttime;
					var date = new Date(time);
		    	var time3 = Date.parse(date);
		    	console.log(time3);//1398250549000
					let id =localStorage.codeId//获取吊牌id
					var params = Qs.stringify({
					    id:id,
					    time:time3,
					    lat:sessionStorage.lat,
 							lon:sessionStorage.lng,	
					});
					addScanner(params)
			    .then(res => {
						console.log("添加扫码记录返回数据：",res);
			      if (res.data.header.status == 1000) {
							console.log('添加扫码记录成功')
			      }else{
				      this.$alert("<p>" + res.data.header.message + "</p>", {
								confirmButtonText: this.$t("prompt.sure"),
								dangerouslyUseHTMLString: true
								});
							return false;
	      		}
			    })
			    .catch(error => {
			      console.log(error);
			    });
		},
//=======获取url指定参数
		GetUrlParam(paraName){
	　　　　var url = document.location.toString();
	　　　　var arrObj = url.split("?");
	　　　　if (arrObj.length > 1) {
	　　　　　　var arrPara = arrObj[1].split("&");
	　　　　　　var arr;
	　　　　　　for (var i = 0; i < arrPara.length; i++) {
	　　　　　　　　arr = arrPara[i].split("=");	
	　　　　　　　　if (arr != null && arr[0] == paraName) {
	　　　　　　　　　　return arr[1];
	　　　　　　　　}
	　　　　　　}
	　　　　　　return "";
	　　　　}
	　　　　else {
	　　　　　　return "";
	　　　　}
	　　},
		//关闭简介
		introductClose(){
			this.isintroduction = false;
		},
		//展示简介
		showintroduct(){
			this.isintroduction = true;
		},
	
    //登录后获得的丢失时间转换分割
    timeconversion(Ltime){
    	let timearr= [];
    	var timezone = new Date().getTimezoneOffset()*60000;   	
    	let timestamp = Ltime - timezone;    	
		  let time = new Date(timestamp);		  
		  let year = time.getFullYear();		  
		  let month = (time.getMonth() + 1 < 10 ? "0" + (time.getMonth() + 1) : time.getMonth() + 1);		 
		  let strDate = (time.getDate() < 10 ? "0" + time.getDate() : time.getDate());
		 	var currentdate = year + '-' + month + '-' + strDate;
			this.losttime = currentdate;
    },
   	//丢失图片格式转换
  	getlossimg(lossimgs){
  			var	lossimg = lossimgs.split(',');
		  	var imgarr = [];
				for(var i=0;i<lossimg.length;i++){
					var imgurl = lossimg[i].replace('[','').replace('"','').replace('"','').replace(']','');
					imgarr.push(imgurl);
				}
			if(lossimg.length==1){
					this.imgflag = true;
					this.avatar = imgarr[0];
			}else if(lossimg.length==2){
					this.imgflag = true;
        	this.imgflag1 = true;
					this.avatar = imgarr[0];
      		this.avatar2 = imgarr[1];
			}else if(lossimg.length==3){
					this.imgflag = true;
        	this.imgflag1 = true;
       	 	this.imgflag2 = true;
					this.avatar = imgarr[0];
      		this.avatar2 = imgarr[1];
        	this.avatar3 = imgarr[2]; 
			}
  		},

  },
  beforeUpdate() {

  },
  filters: {
    infosCmputed: function(value) {
      if (value == "TAG") return this.$t("prompt.QrCode");
    },
    lowercase: function(value) {
      return value.toLowerCase();
    }
  },
  components: {
    "v-header": header,
    "v-introduction":introduction,
    "v-menus":menus,
    "v-scanningrecord":scanningrecord,
    "v-lostpetinfo":lostpetinfo,
  }
};
</script>
<style>
	.pet .el-input .el-input__inner{
  border: none;
  border-color:#fff !important;
  border-bottom: solid 1px #fff;
  width: 100%;
  box-sizing: border-box;
  text-align: center !important;
  height: 1.8rem !important;
  line-height: 1.8rem !important;
  padding: 0 0.5rem 0 1rem !important;
  font-size: 0.8rem;
  border-radius: 0;
  color: #fff;
  background-color: transparent;
}
.pet .el-select,.pet .el-input{
  width: 100%;
	color: #fff;
}
.el-select .el-input .el-select__caret{
	color: #fff;
}
.el-input__icon{
	line-height: 30px;
}
.el-select .el-input .is-focus .el-input__inner{
	border-color:#fff;
}
.el-select:hover .el-input__inner {
    border-color: #fff;
}
.el-input__inner::-webkit-input-placeholder{
    color:#fff;
}
.el-input__inner:-moz-placeholder{
    color:#fff;
}
.el-input__inner::-moz-placeholder{
    color:#fff;
}
.el-input__inner:-ms-input-placeholder{
    color:#fff;
}



/*======宠物走失信息=======*/
.releaseSearch {
	position: relative;
    width: 92%;
    height: 32rem;
    margin-left: 4%;
}
.title .el-input__inner {
    font-size: 0.75rem;
    border-top-color: white;
    border-right-color: white;
    border-left-color: white;
}
.title .el-input__inner:hover {
    border-top-color: white;
    border-right-color: white;
    border-left-color: white;
}
.releaseSearch .el-textarea__inner {
    font-size: 0.75rem;
    border-top-color: white;
    border-right-color: white;
    border-left-color: white;
    padding: 0;
    padding-top: 10px;
}

.releaseSearch .el-button--primary {
    width: 72%;
    margin-left: 14%;
    font-size: 1rem;
    height: 2.6rem;
    line-height: 2.6rem;
    color: rgb(255,255,255);
    margin-top: 30px;
    border-radius: 1.3rem;
    background-image: linear-gradient(to right , #65d3e8, #7dc3f2);
    border: 0;
    padding: 0 0;
}
.releaseSearch .el-date-editor.el-input,
.el-date-editor.el-input__inner {
    border: none;
    margin-left: 0;
}
.el-date-editor.el-input, .el-date-editor.el-input__inner{
	width: 100%;
}
.el-input--prefix .el-input__inner{
	height: 3rem;
	line-height: 3rem;
	border: none;
	text-align: right;
	padding: 0;
	font-size: .8rem;
	color:#606266;
}
.el-popper{
	margin-top: 0 !important;
	margin: 0 auto;
}
.el-date-picker{
	left: 7% !important;	
}
.el-input__prefix{
	display: none;
}
.el-input__suffix{
	left: 0;
}
.releaseSearch .el-textarea__inner::-webkit-input-placeholder{
    color:#000;
}
.releaseSearch .el-textarea__inner:-moz-placeholder{
    color:#000;
}
.releaseSearch .el-textarea__inner::-moz-placeholder{
    color:#000;
}
.releaseSearch .el-textarea__inner:-ms-input-placeholder{
    color:#000;
}

</style>
<style scoped>

.home {
  width: 100%;
}
.home .el-button--primary { /*激活按钮*/
    width: 72%;
    margin-left: 14%;
    font-size: 1.2rem;
    height: 2.6rem;
    line-height: 2.6rem;
    color: rgb(255,255,255);
    margin-top: 30px;
    border-radius: 1.3rem;
    background-image: linear-gradient(to right , #65d3e8, #7dc3f2);
    border: 0;
    padding: 0 0;
}	
img {
  width: 100%;
}
.allinfo{
	width: 100%;
	height: 100%;
	min-height: 25rem;
	background: url(../../../static/img/mainbg.png) top center #fff no-repeat;
  background-size: 100% auto;
}
.title {
    padding-top: 2rem;
}
.title ul{
	position: relative;
}
.title ul li{
    text-align: center;
    color: #000;
    font-size: .9rem;
    font-weight: bold;	
    font-family:PingFang SC;
}
.title ul p{
		text-align: right;
    color: #fff;
    font-size: .8rem;
    width: 20%;
    font-weight: bold;
    font-family: PingFang SC;
    height: 1rem;
    display: inline-block;
    position: absolute;
    right: 2%;
    top: -25px;
}
.title ul p img{
	    width: 1rem;
	    padding-right: 10%;
	    vertical-align: middle;
	    margin-top: -5px;
}

.device_content {
  padding: 10px;
}
.device_content .device_title,
.device_box {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  font-size: 0.85rem;
  padding: 5px 0;
  border-bottom: 1px solid #eee;
}
.device_content .device_code,
.device_box .device_code {
  flex: 6;
  color: #3f3f3f;
}
.device_content .bind_pet,
.device_box .bind_pet {
  flex: 18;
  padding-left: 10px;
}
.device_box {
  padding: 10px 0;
}
.device_box .bind_pet {
  border-left: 1px solid #eee;
  display: flex;
}
.device_code img {
  width: 1.5rem;
  display: block;
  margin: 0 auto;
}
.device_code span {
  display: block;
  margin-top: 5px;
  font-size: 0.5rem;
  text-align: center;
}
.bind_pet img {
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
}
.bind_pet span {
  padding-left: 20px;
  color: #808080;
  font-size: 1rem;
  line-height: 65px;
}


.lossbtn{
    position: absolute;
    bottom: .5rem;
    right: 20px;
    text-align: center;
    height: 1.2rem;
    width: 4.5rem;
    line-height: 1.2rem;
    color: #fff;
    font-size: 0.7rem;
    border: solid 1px #fff;
    border-radius: .6rem;
}
.lostsign{
	width: 4.5rem;
	height: 4.5rem;
	position: absolute;
	top: 0;
	right: 0;
	z-index: 22;
  transform: rotate(30deg);
}
.lostsign li{
    width: 4rem;
    height: 4rem;
		color: #e34139;
    font-size: .1rem;
    display: inline-block;
    position: absolute;
    top: .3rem;
    left: .2rem;
    text-align: center; 
    transform: rotateZ(155deg);
}
.lostsign li span { position: absolute; display: inline-block; left: 0; right: 0; top: 0; bottom: 0; text-transform: uppercase; transition: all 0.5s cubic-bezier(0, 0, 0, 1); }
.lostsign li span:nth-child(1){
transform: rotateZ(0deg) translate3d(0px, 0px, 0px);	
}
.lostsign li span:nth-child(2){
transform: rotateZ(15deg) translate3d(0px, 0px, 0px);	
}
.lostsign li span:nth-child(3){
transform: rotateZ(30deg) translate3d(0px, 0px, 0px);	
}
.lostsign li span:nth-child(4){
transform: rotateZ(45deg) translate3d(0px, 0px, 0px);	
}
.lostsign li span:nth-child(5){
transform: rotateZ(60deg) translate3d(0px, 0px, 0px);	
}
.lostsign li span:nth-child(6){
transform: rotateZ(75deg) translate3d(0px, 0px, 0px);	
}
.lostsign li span:nth-child(7){
transform: rotateZ(90deg) translate3d(0px, 0px, 0px);	
}
.lostsign li span:nth-child(8){
transform: rotateZ(105deg) translate3d(0px, 0px, 0px);		
}
.lostsign li span:nth-child(9){
transform: rotateZ(120deg) translate3d(0px, 0px, 0px);		
}
.lostsign li span:nth-child(10){
transform: rotateZ(135deg) translate3d(0px, 0px, 0px);		
}
.lostsign img{
	width: 100%;
}
/*宠物信息*/
.petinfo {
  width: 100%;
  max-width: 579px;
  height: 177px;
  background: url(../../../static/img/petinfobg.png) top center no-repeat;
  background-size: 100% auto;
  position: relative;
  margin-top: 5%;
}
.petinfo .danger {
  font-size: 0.625rem;
  color: red;
  margin-top: 5px;
}

.petinfo-main {
  position: absolute;
  bottom: 0;
  width: 92%;
  margin: 0 4%;
  max-width: 579px;
  overflow: hidden;
  touch-action: none;
}
.head_img {
    margin-top: 15%;
    margin-left: 5%;
    width: 4.5rem;
    height: 4.5rem;
    position: absolute;
    border: none;
    border-radius: 50%;
    overflow: hidden;
}
.head_img img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
}
.pet {
    width: 60%;
    position: absolute;
    top: 0;
    right: 20px;
}
.pet ul{
  margin-top: 2rem;
}
.pet ul li{
  list-style: none;
  width: 100%;
  position: relative;
}
.petNewsIcon{
    position: absolute;
    font-size: .5rem;
    display: block;
    height: 1.8rem;
    line-height: 1.8rem;
    z-index: 999;
    color: #fff;
}
.petNewsIcon img{
  width: .9rem;
  vertical-align: middle;
  margin: 0 0.5rem;
      margin-left: 0;
}
.pet ul li p{
    width: 100%;
    box-sizing: border-box;
    text-align: center;
    border-bottom: 1px solid #eaeef9;
    height: 1.8rem;
    line-height: 1.8rem;
    font-size: .8rem;
    color: #fff;
}

.pet .el-input .el-input__inner{
  border: none;
  border-color:#fff !important;
  border-bottom: solid 1px #fff;
  width: 100%;
  box-sizing: border-box;
  text-align: center;
  height: 1.8rem;
  line-height: 1.8rem;
  padding: 0 0.5rem 0 1rem;
  font-size: 0.8rem;
  border-radius: 0;
  color: #fff;
  background-color: transparent;
}
.pet .el-select,.pet .el-input{
  width: 100%;
	color: #fff;
}
.el-select .el-input .el-select__caret{
	color: #fff;
}
.el-select .el-input .is-focus .el-input__inner{
	border-color:#fff;
}
.el-select:hover .el-input__inner {
    border-color: #fff;
}
.el-input__inner::-webkit-input-placeholder{
    color:#fff;
}
.el-input__inner:-moz-placeholder{
    color:#fff;
}
.el-input__inner::-moz-placeholder{
    color:#fff;
}
.el-input__inner:-ms-input-placeholder{
    color:#fff;
}



/*主人信息*/
.mynews .el-button--primary{
background-color: rgb(9,81,150);
border-color: rgb(9,81,150);
}
.sel {
  width: 75%;
  box-sizing: border-box;
  text-align: right;
}
.sel .el-input {
  height: 2.5rem;
  line-height: 2.5rem;
  text-align: right;
}
.sel .el-input__inner {
  border-radius: 0;
  border: 0;
  font-size: 0.8rem;
  height: 2.5rem;
  line-height: 2.5rem;
  color: #3f3f3f;
  text-align: right;
  background: transparent;
}
.mynews{
	height: 177px;
  	max-width: 579px;
	background: url(../../../static/img/myinfobg.png) top center no-repeat;
  	background-size: 100% auto;
  	width: 100%;
    position: relative;
    margin-top: 2%;
    z-index: 10;
}
.new{
	height: 177px;
  	width: 70%;
    position: absolute;
    top: 3%;
    right: 15%;
}

.news{
    width: 70%;
    position: absolute;
    top: 8%;
    right: 15%;
}
.news .pos {
  width: 100%;
  display: inline-flex;
  justify-content: space-between;
  border-bottom: 1px solid #fff;
}
.pos input {
  width: 96%;
  border: 0px;
  box-sizing: border-box;
  height: 1.6rem;
  line-height: 1.6rem;
  font-size: 0.8rem;
  background: transparent;
  color: #fff;
  text-align: center;
  padding-left: 15%;
}
.pos input::-webkit-input-placeholder{
    color:#fff;
}
.pos input:-moz-placeholder{
    color:#fff;
}
.pos input::-moz-placeholder{
    color:#fff;
}
.pos input:-ms-input-placeholder{
    color:#fff;
}


.pos input:disabled {
  border-radius: 0;
  border: 0px;
  opacity: 1;
  text-align: center;
  color: #fff;
}
.pos input:focus,
.pos select:focus {
  outline: none;
}
.news span {
	position: absolute;
    font-size: .5rem;
    display: block;
    height: 1.6rem;
    line-height: 1.6rem;
    z-index: 999;
    color: #fff;
}
.news span img{
    width: .9rem;
    vertical-align: middle;
    margin: 0 0.5rem;
        margin-left: 0;
}
.denger{
  font-size: .625rem;
  margin-top: 5px;
  color: red;
}
.news .el-button {
  width: 72%;
  margin-left: 14%;
  font-size: 1rem;
  height: 2.6rem;
  line-height: 2.6rem;
  color: rgb(255,255,255);
  margin-top: 30px;
  border-radius: 1.3rem;
  background-image: linear-gradient(to right , #65d3e8, #7dc3f2);
  border: 0;
  padding: 0 0;
}
.hiddenInput {
  display: none;
}
.menus{
	width: 3rem;
	height: 3rem;
	position: fixed;
	right: 0;
	bottom: 0;
	z-index: 10001;
}
.menus img{
	width: 100%;
}

@media screen and (max-width: 321px) {
	.home .el-button--primary{
		margin: 1rem auto !important;
	}
	.pet span{
	    font-size: 0.78rem !important;
	}
	.pet ul{
	  margin-top: 2rem;
	} 
		.mynews{
		margin-top: -6%;
	}
	.news{
		top:10%;
	}
	.news span {
	  height: 1.6rem;
	  line-height: 1.6rem;
	}
	.pos input{
		height: 1.6rem;
	  line-height: 1.6rem;
	} 
	.lossbtn{
		bottom: 2rem;
	}
}
@media (min-width: 411px) and (max-width: 578px) {
	.petinfo-main{
		height: 193px !important;
	}
	.petinfo{
		height: 193px;
	}
	.lossbtn{
		bottom: .5rem;
	}
	.mynews{
		height: 193px;
		margin-top: 4%;
	}	
}



.disable{
	position: absolute;
	width: 100%;
	height: 350px;
	top: 0;
	z-index: 999;
}

.addtext {
    text-align: center;
    padding: 20px 0;
    margin-bottom: 20px;
    font-size: .8rem;
    color: rgb(130, 130, 130);
    letter-spacing: 1px;
}
.releaseSearch .danger {
    font-size: 0.625rem;
    color: red;
    margin-top: 5px;
}

.describe {
    width: 100%;
    margin: 0 auto;
}
.describe span{
	font-size: .8rem;
	color: #606266;
	padding-bottom: 10px;
}
.time {
    border-bottom: solid 1px rgb(230, 230, 230);
	height: 3rem;
}
.time p {
	display: inline-block;
    width: 30%;
    font-size: .8rem;
	line-height: 3rem;
    float: left;
}
.time p img{
	width: .9rem;
    vertical-align: middle;
    margin-right: .3rem;	
}
.block{
	width: 70%;
	float: right;
}
.loseplace {
    border-bottom: solid 1px rgb(230, 230, 230);
    height: 3rem;
}
.loseplace span{
	display: inline-block;
    width: 30%;
    font-size: .8rem;
	line-height: 3rem;
    float: left;
}
.loseplace span img{
	width: .9rem;
    vertical-align: middle;
    margin-right: .3rem;
}
.loseplace p {
	width: 70%;
	float: right;
	text-align: right;
    font-size: 0.875rem;
	line-height: 3rem;
}
.loseplace p:nth-child(2) {
    font-size: 0.75rem;
    line-height: 3rem;
     color: #606266;
}

.petphoto .delete {
    position: absolute;
    width: 15px;
    height: 15px;
    top: 40px;
    left: 5px;
}
.petphoto .delete1 {
    position: absolute;
    width: 15px;
    height: 15px;
    top: 40px;
    left: 85px;
}
.petphoto .delete2 {
    position: absolute;
    width: 15px;
    height: 15px;
    top: 40px;
    left: 160px;
}

.petphoto {
    border-bottom: solid 1px rgb(230, 230, 230);
    padding-bottom: 10px;
    position: relative;
}
.petphoto p {
	display: inline-block;
    width: 100%;
    font-size: .8rem;
	line-height: 3rem;
}
.petphoto p img{
	width: .9rem !important;
	height: auto !important;
    vertical-align: middle;
    margin-right: .3rem !important;	
    margin-left: 0 !important;	
}
.petphoto img {
    object-fit:cover;
    width: 60px;
    height: 60px;
    margin-right: 15px;
}

.el-message {
    width: 80%;
}

.hiddenInput {
    display: none;
}
.hiddenInput1 {
    display: none;
}
.hiddenInput2 {
    display: none;
}
.main {
    position: absolute;
    top: 55px;
    bottom: 0;
    width: 100%;
    overflow: hidden;
    touch-action: none;
}

@media screen and (max-width: 321px) {
	.petphoto .delete,.petphoto .delete1,.petphoto .delete2 {
	    top: 32px;
	}


}


</style>



// WEBPACK FOOTER //
// src/m_page/finder/qrFindPet.vue